import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getOffers } from "@/services/apiOffers";

export function useOffers({ filter, include, includeFields, sortBy, page, perPage }) {
  const queryClient = useQueryClient();

  const {
    isPending,
    isSuccess,
    data: offers,
  } = useQuery({
    queryKey: ["offers", filter, include, sortBy, page, perPage, includeFields],
    queryFn: () => getOffers({ filter, include, sortBy, page, perPage, includeFields }),
  });

  const totalPages = Math.ceil(offers?.meta?.total / offers?.meta?.per_page);

  // PRE-FETCHING
  if (isSuccess && page < totalPages) {
    queryClient.prefetchQuery({
      queryKey: ["offers", filter, include, sortBy, page, perPage, includeFields],
      queryFn: () => getOffers({ filter, include, sortBy, page: page++, perPage, includeFields }),
    });
  }

  if (isSuccess && page > 1) {
    queryClient.prefetchQuery({
      queryKey: ["offers", filter, include, sortBy, page, perPage, includeFields],
      queryFn: () => getOffers({ filter, include, sortBy, page: page--, perPage, includeFields }),
    });
  }

  return { isPending, offers };
}
